var Haiku = require("@haiku/core");
var _code_circle_code = require("./../circle/code.js");
module.exports = {
  metadata: {
    uuid: "58cfb188-fd09-4522-857f-5c360ba7039e",
    version: "0.0.1",
    organization: "Tina",
    project: "AnimatorWebsiteIcon3",
    branch: "master",
    folder: "/Users/agustina/.haiku/projects/Tina/AnimatorWebsiteIcon3",
    username: "tina@haiku.ai",
    root: "https://cdn.haiku.ai/ecbab1b7-350c-4db4-ae46-f4da53963612/80b581d854fba9f81f33f065dfdb5d5b95871c62/",
    core: "4.5.0",
    title: "Main",
    type: "haiku",
    relpath: "code/main/code.js"
  },
  options: {},
  states: { play: { type: "string", value: "stop", edited: true } },
  eventHandlers: {
    "haiku:Main-03757d2ca1026e0a": {
      hover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "loop" });
        }
      },
      unhover: {
        handler: function(component, element, target, event) {
          this.setState({ play: "stop" });
        }
      }
    }
  },
  timelines: {
    Default: {
      "haiku:Page-1-495b936d775bd71b": {
        stroke: "none",
        strokeWidth: 1,
        fill: "none",
        fillRule: "evenodd"
      },
      "haiku:Main-03757d2ca1026e0a": {
        "style.WebkitTapHighlightColor": "rgba(0,0,0,0)",
        "style.position": "relative",
        "style.overflowX": "hidden",
        "style.overflowY": "hidden",
        "sizeAbsolute.x": 75.575,
        "sizeAbsolute.y": 76.674,
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeMode.z": 1
      },
      "haiku:Code-Icon-bfe08a8c33848ff8": {
        "sizeMode.x": 1,
        "style.position": "absolute",
        "style.padding": "0",
        "style.border": "0",
        "sizeAbsolute.x": 46,
        "style.margin": "0",
        "sizeAbsolute.y": 23,
        "sizeMode.y": 1,
        "translation.x": 37.78750000000001,
        "translation.y": 37.99998474121094,
        "style.zIndex": 2
      },
      "haiku:Linear-Gradient-1-Ec20bc-b036e44b3d0b4ff0": {
        x1: "24.659504%",
        y1: "40.0186951%",
        x2: "80.3495914%",
        y2: "57.7030424%"
      },
      "haiku:Stop-1432e3d34d3eea07": { stopColor: "#8934FF", offset: "0%" },
      "haiku:Stop-2719a1cdd0637513": { stopColor: "#04B6CB", offset: "100%" },
      "haiku:Npm-Icon-5eadcc51aff99800": {
        fill: "url(#linearGradient-1-ec20bc)",
        "translation.x": -12,
        "translation.y": -19
      },
      "haiku:Code-Icon-0cb0a430b3145312": {
        d:
          "M23.2,41.4 C22.8928,41.4 22.5856,41.2824 22.3504,41.0496 L12.7504,31.4496 C12.2824,30.9816 12.2824,30.2208 12.7504,29.7528 L22.3504,20.1528 C22.8184,19.6848 23.5792,19.6848 24.0472,20.1528 C24.5152,20.6208 24.5152,21.3816 24.0472,21.8496 L15.2968,30.6 L24.0472,39.3504 C24.5152,39.8184 24.5152,40.5792 24.0472,41.0472 C23.812,41.2824 23.5048,41.3976 23.1976,41.3976 L23.2,41.4 Z M47.2,41.4 C46.8928,41.4 46.5856,41.2824 46.3504,41.0496 C45.8824,40.5816 45.8824,39.8208 46.3504,39.3528 L55.1008,30.6024 L46.3504,21.852 C45.8824,21.384 45.8824,20.6232 46.3504,20.1552 C46.8184,19.6872 47.5792,19.6872 48.0472,20.1552 L57.6472,29.7552 C58.1152,30.2232 58.1152,30.984 57.6472,31.452 L48.0472,41.052 C47.812,41.2872 47.5048,41.4024 47.1976,41.4024 L47.2,41.4 Z M29.2,41.4 C28.9816,41.4 28.7632,41.34 28.564,41.2176 C28.0024,40.8672 27.832,40.1256 28.1824,39.564 L40.1824,20.364 C40.5328,19.8024 41.2744,19.632 41.836,19.9824 C42.3976,20.3328 42.568,21.0744 42.2176,21.636 L30.2176,40.836 C29.9896,41.2008 29.5984,41.4 29.2,41.4 Z"
      },
      "haiku:Circle-55cdabc6476eeb96": {
        "style.position": "absolute",
        "translation.x": 37.49999999999999,
        "style.padding": "0",
        "style.border": "0",
        "sizeMode.x": 1,
        "sizeMode.y": 1,
        "sizeAbsolute.x": "auto",
        "style.margin": "0",
        "sizeAbsolute.y": "auto",
        "translation.y": 38.337,
        "sizeMode.z": 1,
        "origin.x": 0.5,
        "origin.y": 0.5,
        "style.zIndex": 1,
        playback: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        },
        PlayIt: {
          "0": {
            value: Haiku.inject(function(play) {
              return play;
            }, "play"),
            edited: true
          }
        }
      }
    }
  },
  template: {
    elementName: "div",
    attributes: { "haiku-id": "Main-03757d2ca1026e0a", "haiku-title": "Main" },
    children: [
      {
        elementName: _code_circle_code,
        attributes: {
          "haiku-id": "Circle-55cdabc6476eeb96",
          "haiku-var": "_code_circle_code",
          "haiku-title": "Circle",
          "haiku-source": "./code/circle/code.js"
        },
        children: []
      },
      {
        elementName: "svg",
        attributes: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          "haiku-id": "Code-Icon-bfe08a8c33848ff8",
          "haiku-title": "Code-icon",
          "haiku-source":
            "designs/AnimatorWebsiteIcon3.sketch.contents/slices/Code-icon.svg"
        },
        children: [
          {
            elementName: "defs",
            attributes: { "haiku-id": "Defs-1070aead04bcd3b2" },
            children: [
              {
                elementName: "linearGradient",
                attributes: {
                  "haiku-id": "Linear-Gradient-1-Ec20bc-b036e44b3d0b4ff0",
                  id: "linearGradient-1-ec20bc"
                },
                children: [
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-1432e3d34d3eea07" },
                    children: []
                  },
                  {
                    elementName: "stop",
                    attributes: { "haiku-id": "Stop-2719a1cdd0637513" },
                    children: []
                  }
                ]
              }
            ]
          },
          {
            elementName: "g",
            attributes: { "haiku-id": "Page-1-495b936d775bd71b", id: "Page-1" },
            children: [
              {
                elementName: "g",
                attributes: {
                  "haiku-id": "Npm-Icon-5eadcc51aff99800",
                  id: "NPM-icon"
                },
                children: [
                  {
                    elementName: "path",
                    attributes: {
                      "haiku-id": "Code-Icon-0cb0a430b3145312",
                      id: "Code-icon"
                    },
                    children: []
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/@haiku/tina-animatorwebsiteicon3/code/main/code.js
// module id = 443
// module chunks = 35783957827783